import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { PageLayout, PageHeader, PageCard, pageStyles } from '../PageLayout';

const SettingsView = ({ user, onEditUser }: any) => {
    const { theme, setTheme, isDark } = useTheme();
    
    return (
        <PageLayout>
            <PageHeader
                title="Einstellungen"
                actions={onEditUser && (
                    <button
                        type="button"
                        onClick={() => onEditUser(user)}
                        className={`px-4 py-2 rounded-xl text-sm font-semibold border ${isDark ? 'border-white/30 text-white hover:bg-white/10' : 'border-slate-300 text-slate-700 hover:bg-slate-100'}`}
                    >
                        Profil bearbeiten
                    </button>
                )}
            />
            <PageCard className="p-6">
                <div className="flex items-center gap-4 mb-8">
                    <div className={`w-20 h-20 border rounded-full flex items-center justify-center text-3xl font-bold shadow-lg ${
                        isDark 
                            ? 'bg-gradient-to-br from-blue-500/60 via-indigo-500/50 to-cyan-400/50 border-white/10 text-white' 
                            : 'bg-gradient-to-br from-blue-500 via-indigo-500 to-cyan-400 border-blue-200 text-white'
                    }`}>
                        {user.name[0]}
                    </div>
                    <div>
                        <h3 className={`text-xl font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>{user.name}</h3>
                        <p className={`capitalize ${isDark ? 'text-white/70' : 'text-slate-600'}`}>{user.role}</p>
                    </div>
                </div>

                {/* Darstellung / Dark Mode */}
                <div className={`p-4 rounded-xl border mb-6 ${isDark ? 'bg-white/5 border-white/10' : 'bg-slate-50 border-slate-200'}`}>
                    <label className={`block text-xs font-bold uppercase mb-3 ${isDark ? 'text-white/60' : 'text-slate-600'}`}>Darstellung</label>
                    <div className="flex flex-wrap gap-2">
                        <button
                            type="button"
                            onClick={() => setTheme('light')}
                            className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-sm font-medium transition-colors ${
                                theme === 'light'
                                    ? isDark ? 'bg-blue-500/30 text-blue-300 border border-blue-400/50' : 'bg-blue-100 text-blue-700 border border-blue-200'
                                    : isDark ? 'bg-white/5 text-white/70 border border-white/10 hover:bg-white/10' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'
                            }`}
                        >
                            <Sun size={18} /> Hell
                        </button>
                        <button
                            type="button"
                            onClick={() => setTheme('dark')}
                            className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-sm font-medium transition-colors ${
                                theme === 'dark'
                                    ? isDark ? 'bg-blue-500/30 text-blue-300 border border-blue-400/50' : 'bg-blue-100 text-blue-700 border border-blue-200'
                                    : isDark ? 'bg-white/5 text-white/70 border border-white/10 hover:bg-white/10' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'
                            }`}
                        >
                            <Moon size={18} /> Dunkel
                        </button>
                        <button
                            type="button"
                            onClick={() => setTheme('system')}
                            className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-sm font-medium transition-colors ${
                                theme === 'system'
                                    ? isDark ? 'bg-blue-500/30 text-blue-300 border border-blue-400/50' : 'bg-blue-100 text-blue-700 border border-blue-200'
                                    : isDark ? 'bg-white/5 text-white/70 border border-white/10 hover:bg-white/10' : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'
                            }`}
                        >
                            <Monitor size={18} /> System
                        </button>
                    </div>
                    <p className={`text-xs mt-2 ${isDark ? 'text-white/50' : 'text-slate-500'}`}>
                        „System“ nutzt die Einstellung von Windows bzw. deinem Gerät.
                    </p>
                </div>

                <div className="space-y-4">
                    <div className={`p-4 rounded-xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-slate-50 border-slate-200'}`}>
                        <label className={`block text-xs font-bold uppercase mb-1 ${isDark ? 'text-white/60' : 'text-slate-600'}`}>E-Mail / Benutzername</label>
                        <div className={`font-medium ${isDark ? 'text-white' : 'text-slate-900'}`}>{user.email || 'Keine E-Mail hinterlegt'}</div>
                    </div>
                    <div className={`p-4 rounded-xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-slate-50 border-slate-200'}`}>
                        <label className={`block text-xs font-bold uppercase mb-1 ${isDark ? 'text-white/60' : 'text-slate-600'}`}>ADV / ADP Nummer</label>
                        <div className={`font-medium ${isDark ? 'text-white' : 'text-slate-900'}`}>{user.adv || '-'}</div>
                    </div>
                    <div className={`p-4 rounded-xl border ${isDark ? 'bg-white/5 border-white/10' : 'bg-slate-50 border-slate-200'}`}>
                        <label className={`block text-xs font-bold uppercase mb-1 ${isDark ? 'text-white/60' : 'text-slate-600'}`}>Login Code</label>
                        <div className={`font-medium font-mono tracking-widest ${isDark ? 'text-white' : 'text-slate-900'}`}>••••</div>
                    </div>
                </div>
            </PageCard>
        </PageLayout>
    );
};

export default SettingsView;
